import { AnimatePresence } from '@eversports/klimt-utilities/framer-motion'

import Footer from '../../components/Footer'
import Header from '../../components/Header'

import InvoiceHistory from './InvoiceHistory'

const InvoiceHistoryPage = () => {
  return (
    <>
      <Header />
      <AnimatePresence mode="wait">
        <InvoiceHistory />
      </AnimatePresence>
      <Footer />
    </>
  )
}

export default InvoiceHistoryPage
